var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"witdh":"100%","height":"100%"}},[_c('WindowFrame',{ref:"windowframe_trello",staticClass:"ma-0 pa-0",attrs:{"component":'trello',"input_args":_vm.input_args_trello}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }